import React from 'react';
import { Box, Grid } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import BarChartIcon from '@mui/icons-material/BarChart';

import StatCard from './StatCard';
import ChartCard from './ChartCard';
import SatisfactionTrendChart from './charts/SatisfactionTrendChart';
import SQDChart from './charts/SQDChart'; 
import { themeColors } from '../common/constants';

const DashboardTab = ({ 
  dashboardStats, 
  satisfactionTrendData, 
  sqdChartData,
  dateRange,
  activeFilters,
  isFiltered,
  onSelectOffice,
  loading 
}) => {
  return (
    <Box>
      <Grid container spacing={3}>
        {/* Stats Row */}
        <Grid item xs={12} md={4}>
          <StatCard 
            icon={<GroupIcon sx={{ color: themeColors.primary }} />}
            title="Total Respondents"
            value={dashboardStats.totalRespondents}
            color={themeColors.primary}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <StatCard 
            icon={<TrendingUpIcon sx={{ color: themeColors.primary }} />}
            title="Avg. Satisfaction Rate"
            value={`${dashboardStats.avgSatisfactionRate}%`}
            subtitle="Based on overall ratings"
            color={themeColors.primary}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <StatCard 
            icon={<BarChartIcon sx={{ color: themeColors.primary }} />}
            title="Avg. Time to Complete"
            value={`${dashboardStats.averageTimeToComplete} minute/s`}
            subtitle="Survey completion time"
            color={themeColors.primary}
          />
        </Grid>
        
        {/* Charts Row */}
        <Grid item xs={12} md={6}>
          <ChartCard title="Satisfaction Trend">
              <SatisfactionTrendChart
              
              loading={false}
              dateRange={dateRange}
              isFiltered={isFiltered}
              activeFilters={activeFilters}
              showAverage={true}
              showTarget={true}
              targetValue={85}
              height={500}
              title="Customer Satisfaction Score (CSAT)"
              themeColors={{
                primary: "#4F46E5", 
                secondary: "#16A34A", 
                tertiary: "#8B5CF6", 
                accent: "#F59E0B"  
              }}
            />
          </ChartCard>
        </Grid>
        <Grid item xs={12} md={6}>
          <ChartCard title="Client Type Distribution">
            <SQDChart sqdChartData={sqdChartData} />
          </ChartCard>
        </Grid>
        
      </Grid>
    </Box>
  );
};

export default DashboardTab;